<template>
  <i class="ai-cursor" aria-hidden="true"></i>
</template>

<style scoped>
.ai-cursor {
  display: inline-block;
  width: 2px;
  height: 1em;
  margin-left: 2px;
  vertical-align: text-bottom;
  background: #6366f1;
  animation: ai-cursor-blink 1s steps(1) infinite;
}
@keyframes ai-cursor-blink {
  0%,
  50% {
    opacity: 1;
  }
  50.01%,
  100% {
    opacity: 0;
  }
}
</style>
